{
    "name": "slimsdk",
    "version": "0.2.11",
    "description": "WebApp SDK",
    "type": "module",
    "exports": {
        ".": "./dist/index.js",
        "./desktop": "./dist/desktop/index.js",
        "./desktop/": "./dist/desktop/",
        "./mobile": "./dist/mobile/index.js",
        "./mobile/": "./dist/mobile/",
        "./lib": "./dist/lib/index.js",
        "./svchub": "./dist/svchub/index.js",
        "./worker/": "./dist/worker/*.js",
        "./page": "./dist/page/index.js",
        "./page/*": "./dist/page/*/index.js",
        "./page/*.css": "./dist/page/*.css",
        "./mod": "./dist/mod/index.js",
        "./mod/*": "./dist/mod/*/index.js",
        "./mod/*.css": "./dist/mod/*.css",
        "./css/": "./dist/css/"
    },
    "files": [
        "dist"
    ],
    "scripts": {
        "dev": "tsup --watch",
        "build": "tsup && sh ./clean.sh"
    },
    "devDependencies": {
        "@eslint/js": "^10.0.1",
        "@types/node": "^25.8.0",
        "eslint": "^10.4.0",
        "globals": "^17.6.0",
        "tsup": "^8.5.1",
        "typescript": "^5.9.3",
        "typescript-eslint": "^8.59.3"
    },
    "license": "MIT",
    "author": "hs3lcs@gmail.com"
}